import {
  View,
  Text,
  Image,
  ScrollView,
  TouchableOpacity,
  TextInput,
} from "react-native";
import React, { useEffect, useState } from "react";
import { StackActions, useNavigation } from "@react-navigation/native";
import { LinearGradient } from "expo-linear-gradient";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  getLocationDetails,
  getLoginData,
} from "../../../utility/AppStoreData";
import { toast } from "react-toastify";
import * as Linking from "expo-linking";
import { fetchPaymentCreateSession } from "../../../services/profileAPI";
import VerificationModal from "./VerificationModal";
import PurchaseSuccess from "./PurchaseSuccess";
import PaymentScreen from "./BeltScreens/PaymentScreen";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { AppScreens } from "../../Utility/AppScreens";
import HomeProfile from "../../../Components/home-common-components/HomeProfile";
import Header from "./Common/Header";
import Separator from "../../../Components/Separator";
import { getUserProfile } from "../../../services/authAPI";
import { ScreenBGGradientView } from "../../../common/CommonView";
import PurchaseScreenSkeleton from "../../../Components/skeleton-components/PurchaseScreenSkeleton";

const PurchaseScreen = ({ route }) => {
  let { eventID } = route.params || {};
  eventID = eventID !== undefined ? eventID : "";
  const eventScreen = route?.params?.screen ? "event" : null;
  // Use type directly for notification/challenge flows, otherwise default to public
  const routeType = route?.params?.type;
  const eventType = routeType ?? "public";

  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [userData, setUserData] = useState(null);
  const [predefinedCustomTokenPackages, setPredefinedCustomTokenPackages] =
    useState(true);
  const [showVerification, setShowVerification] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPurchasing, setIsPurchasing] = useState(false);
  const [showPaymentScreen, setShowPaymentScreen] = useState(false);
  const [paymentCreateSessionData, setPaymentCreateSessionData] =
    useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [userProfileData, setUserProfileData] = useState(null);
  const [location, setLocation] = useState(null);
  console.log("location", location);

  useEffect(() => {
    async function fetchLocation() {
      try {
        const locationData = await getLocationDetails();
        setLocation(locationData);
      } catch (error) {
        toast.error("Failed to fetch location details.");
      }
    }
    fetchLocation();
  }, []);
  useEffect(() => {
    getLoginUserData();
  }, []);
  const [tokenPackages, setTokenPackages] = useState([
    // Bundle #3: Starter - 1 Bronze belt + 27 spare (500 base + 77 bonus)
    {
      tokens: 577,
      baseTokens: 500,
      bonusTokens: 77,
      price: "£5.99",
      exchangeRate: "£0.01",
    },
    // Bundle #4: Competitor - 2 Bronze belts + 27 spare (1,050 base + 77 bonus)
    {
      tokens: 1127,
      baseTokens: 1050,
      bonusTokens: 77,
      price: "£12.79",
      exchangeRate: "£0.01",
    },
    // Bundle #5: Champion - Midpoint bundle, best balance (2,150 base + 77 bonus)
    {
      tokens: 2227,
      baseTokens: 2150,
      bonusTokens: 77,
      price: "£26.29",
      exchangeRate: "£0.01",
    },
    // Bundle #6: Elite - Ideal for regular challengers (4,350 base + 77 bonus)
    {
      tokens: 4427,
      baseTokens: 4350,
      bonusTokens: 77,
      price: "£52.99",
      exchangeRate: "£0.01",
    },
    // Bundle #7: Legend - High-value player bundle (8,750 base + 77 bonus)
    {
      tokens: 8827,
      baseTokens: 8750,
      bonusTokens: 77,
      price: "£106.79",
      exchangeRate: "£0.01",
    },
    // Bundle #8: Pro - Ultimate value bundle (20,250 base + 77 bonus)
    {
      tokens: 20327,
      baseTokens: 20250,
      bonusTokens: 77,
      price: "£246.99",
      exchangeRate: "£0.01",
    },
  ]);

  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
      await userProfileAPI(data.AccessToken);
    }
  }
  const userProfileAPI = async (AccessToken?: string) => {
    setIsLoading(true);

    try {
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      setIsLoading(false);

      if (data.statusCode === 200) {
        setUserProfileData(responseBody);
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };
  async function paymentCreateSessionAPI({
    AccessToken,
    selectedPackage,
    successCallback,
  }) {
    setIsPurchasing(true);
    try {
      const data = await fetchPaymentCreateSession(
        AccessToken,
        selectedPackage.tokens,
        selectedPackage.price,
        eventID,
        location?.country_code,
        eventType,
        eventScreen
      );
      setIsPurchasing(false);

      if (data.statusCode === 303) {
        successCallback(data);
      } else {
        toast.error(
          data.body.error || "An error occurred during payment session creation"
        );
      }
    } catch (error) {
      setIsPurchasing(false);

      toast.error(error.message);
    }
  }

  const handlePackageSelect = (selectedPackage) => {
    setSelectedPackage(selectedPackage);
  };

  const handlePurchase = () => {
    if (selectedPackage) {
      paymentCreateSessionAPI({
        AccessToken: userData?.AccessToken,
        selectedPackage: {
          tokens: selectedPackage.tokens,
          price: selectedPackage.price,
        },
        successCallback: (successData) => {
          Linking.openURL(successData.body.url);
        },
      });
    } else {
      toast.error("Please select a package to purchase.");
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <ScreenBGGradientView />
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen);
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen);
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => { }}
        btnStartTutorialTapped={() => { }}
        btnMessageTapped={() => { }}
        btnNotificationTapped={() => { }}
        btnProfileTapped={() => { }}
      />
      {isLoading ? (
        <PurchaseScreenSkeleton />
      ) : (
        <View style={styles.container}>
          {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
            <>
              {/* Mobile Layout - First Row: Back button + Purchase tokens */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  marginBottom: 15,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    navigation.goBack();
                  }}
                >
                  <LinearGradient
                    colors={["#1F2937", "#111827"]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={{
                      width: 44,
                      height: 44,
                      padding: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 8,
                      borderWidth: 0.8,
                      borderColor: "#374151",
                    }}
                  >
                    <Image
                      source={AppImages.icArrowLeft}
                      style={{
                        height: 24,
                        width: 24,
                        tintColor: AppColors.white,
                      }}
                      resizeMode="contain"
                    />
                  </LinearGradient>
                </TouchableOpacity>
                <Text style={[AppFontStyle.BOLD_ANYBODY_16, {}]}>
                  Purchase tokens
                </Text>
              </View>

              {/* Mobile Layout - Second Row: My Token Balance */}
              <LinearGradient
                colors={["#111827", "#000"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  paddingVertical: 10,
                  paddingHorizontal: 12,
                  borderRadius: 16,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 8,
                  shadowColor: "rgba(232, 232, 232, 0.15)",
                  shadowOffset: { width: 0, height: -1 },
                  shadowOpacity: 1,
                  shadowRadius: 4,
                  elevation: 4,
                }}
              >
                <Text style={[AppFontStyle.BOLD_ANYBODY_14]}>
                  My Token Balance
                </Text>
                <View
                  style={{
                    paddingVertical: 6,
                    paddingHorizontal: 12,
                    flexDirection: "row",
                    alignItems: "center",
                    borderRadius: 16,
                    backgroundColor: AppColors.grayColor_282828,
                    gap: 8,
                  }}
                >
                  <Image
                    source={AppImages.Ko_Token}
                    style={{
                      height: 36,
                      width: 36,
                      objectFit: "contain",
                    }}
                  />
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_20]}>
                    {userProfileData?.tokens}{" "}
                  </Text>
                </View>
              </LinearGradient>
            </>
          ) : (
            /* Desktop Layout - Original single row */
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
              >
                <TouchableOpacity
                  onPress={() => {
                    navigation.goBack();
                  }}
                >
                  <LinearGradient
                    colors={["#1F2937", "#111827"]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={{
                      width: 44,
                      height: 44,
                      padding: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 8,
                      borderWidth: 0.8,
                      borderColor: "#374151",
                    }}
                  >
                    <Image
                      source={AppImages.icArrowLeft}
                      style={{
                        height: 24,
                        width: 24,
                        tintColor: AppColors.white,
                      }}
                      resizeMode="contain"
                    />
                  </LinearGradient>
                </TouchableOpacity>
                <View>
                  <Text style={[AppFontStyle.BOLD_ANYBODY_32, {}]}>
                    Purchase tokens
                  </Text>
                </View>
              </View>
              <LinearGradient
                colors={["#111827", "#000"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  height: 75,
                  padding: 15,
                  paddingHorizontal: 12,
                  borderRadius: 16,
                  width: 591,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  shadowColor: "rgba(232, 232, 232, 0.15)",
                  shadowOffset: { width: 0, height: -1 },
                  shadowOpacity: 1,
                  shadowRadius: 4,
                  elevation: 4,
                }}
              >
                <Text style={[AppFontStyle.BOLD_ANYBODY_24]}>
                  My Token Balance
                </Text>
                <View
                  style={{
                    paddingVertical: 6,
                    paddingHorizontal: 24,
                    flexDirection: "row",
                    alignItems: "center",
                    borderRadius: 16,
                    backgroundColor: AppColors.grayColor_282828,
                    gap: 12,
                  }}
                >
                  <Image
                    source={AppImages.Ko_Token}
                    style={{
                      height: 44,
                      width: 44,
                      objectFit: "contain",
                    }}
                  />
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_35]}>
                    {userProfileData?.tokens}{" "}
                  </Text>
                </View>
              </LinearGradient>
            </View>
          )}

          {/* Separator - Only show on desktop/web */}
          {deviceSize !== DEVICE_SIZES.XS && deviceSize !== DEVICE_SIZES.SM && (
            <View
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#374151",
                marginTop: 20,
                marginBottom: 0,
              }}
            />
          )}

          <ScrollView
            style={{
              marginTop:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 15
                  : 20,
            }}
            contentContainerStyle={{
              paddingBottom: 40,
            }}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
          >
            {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ||
              deviceSize === DEVICE_SIZES.LARGE_DEVICE ||
              deviceSize === DEVICE_SIZES.MEDIUM_DEVICE ? (
              <>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <ScrollView
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ gap: 25 }}
                  >
                    {tokenPackages.slice(0, 4).map((item, index) => {
                      const isSelected =
                        selectedPackage &&
                        selectedPackage.tokens === item.tokens;
                      return (
                        <TouchableOpacity
                          key={index}
                          onPress={() => handlePackageSelect(item)}
                          style={{ position: "relative" }}
                        >
                          <Image
                            source={AppImages.Ko_Token_Bonus_Badge}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              width: 55,
                              height: 18,
                              zIndex: 10,
                              transform: [
                                { translateX: -10 },
                                { translateY: 10 },
                              ],
                            }}
                            resizeMode="contain"
                          />
                          <LinearGradient
                            colors={[
                              "rgba(31, 41, 55, 0.50)",
                              "rgba(17, 24, 39, 0.50)",
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 1 }}
                            style={[
                              {
                                flex: 1,
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 18,
                                borderRadius: 10,
                                marginVertical: 5,
                                marginHorizontal: 5,
                                paddingVertical: 24,
                                paddingHorizontal: 12,
                                width: 264,
                                height: 140,
                                borderWidth: isSelected ? 2.5 : 0.8,
                                borderColor: isSelected
                                  ? AppColors.appViolentColor_6D08C3
                                  : "rgba(139, 147, 176, 0.10)",
                              },
                            ]}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 12,
                                marginTop: 8,
                              }}
                            >
                              <Image
                                source={AppImages.Ko_Token}
                                style={{
                                  height: 60,
                                  width: 60,
                                }}
                              />
                              <View style={{ gap: 6, flex: 1 }}>
                                <Text
                                  style={[
                                    styles.tokenNumberRed,
                                    {
                                      fontFamily: "Anybody_700Bold",
                                      fontSize: 38,
                                      fontWeight: "700",
                                      lineHeight: 38,
                                    },
                                  ]}
                                >
                                  {item.tokens.toLocaleString()}
                                </Text>
                                <Text
                                  style={[
                                    styles.tokenBonusGray,
                                    {
                                      fontFamily: "Anybody_400Regular",
                                      fontSize: 14,
                                      fontWeight: "400",
                                      lineHeight: 16,
                                    },
                                  ]}
                                >
                                  {item.baseTokens.toLocaleString()} +{" "}
                                  {item.bonusTokens} bonus
                                </Text>
                              </View>
                            </View>

                            <Text
                              style={{
                                color: "#FFF",
                                textAlign: "center",
                                fontSize: 37,
                                fontWeight: "700",
                                lineHeight: 36,
                              }}
                            >
                              {item.price}
                            </Text>
                          </LinearGradient>
                        </TouchableOpacity>
                      );
                    })}
                  </ScrollView>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 20,
                    marginBottom: 30,
                  }}
                >
                  <ScrollView
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ gap: 25 }}
                  >
                    {tokenPackages.slice(4, 6).map((item, index) => {
                      const isSelected =
                        selectedPackage &&
                        selectedPackage.tokens === item.tokens;
                      return (
                        <TouchableOpacity
                          key={index}
                          onPress={() => handlePackageSelect(item)}
                          style={{ position: "relative" }}
                        >
                          <Image
                            source={AppImages.Ko_Token_Bonus_Badge}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              width: 55,
                              height: 18,
                              zIndex: 10,
                              transform: [
                                { translateX: -10 },
                                { translateY: 10 },
                              ],
                            }}
                            resizeMode="contain"
                          />
                          <LinearGradient
                            colors={[
                              "rgba(31, 41, 55, 0.50)",
                              "rgba(17, 24, 39, 0.50)",
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 1 }}
                            style={[
                              {
                                flex: 1,
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 18,
                                borderRadius: 10,
                                marginVertical: 5,
                                marginHorizontal: 5,
                                paddingVertical: 24,
                                paddingHorizontal: 12,
                                width: 264,
                                height: 140,
                                borderWidth: isSelected ? 2.5 : 0.8,
                                borderColor: isSelected
                                  ? AppColors.appViolentColor_6D08C3
                                  : "rgba(139, 147, 176, 0.10)",
                              },
                            ]}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 12,
                                marginTop: 8,
                              }}
                            >
                              <Image
                                source={AppImages.Ko_Token}
                                style={{
                                  height: 60,
                                  width: 60,
                                }}
                              />
                              <View style={{ gap: 6, flex: 1 }}>
                                <Text
                                  style={[
                                    styles.tokenNumberRed,
                                    {
                                      fontFamily: "Anybody_700Bold",
                                      fontSize: 38,
                                      fontWeight: "700",
                                      lineHeight: 38,
                                    },
                                  ]}
                                >
                                  {item.tokens.toLocaleString()}
                                </Text>
                                <Text
                                  style={[
                                    styles.tokenBonusGray,
                                    {
                                      fontFamily: "Anybody_400Regular",
                                      fontSize: 14,
                                      fontWeight: "400",
                                      lineHeight: 16,
                                    },
                                  ]}
                                >
                                  {item.baseTokens.toLocaleString()} +{" "}
                                  {item.bonusTokens} bonus
                                </Text>
                              </View>
                            </View>

                            <Text
                              style={{
                                color: "#FFF",
                                textAlign: "center",
                                fontSize: 37,
                                fontWeight: "700",
                                lineHeight: 36,
                              }}
                            >
                              {item.price}
                            </Text>
                          </LinearGradient>
                        </TouchableOpacity>
                      );
                    })}
                  </ScrollView>
                </View>
              </>
            ) : (
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  padding:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 0
                      : 10,
                  marginBottom:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 10
                      : 30,
                }}
              >
                {tokenPackages.map((item, index) => {
                  const isSelected =
                    selectedPackage && selectedPackage.tokens === item.tokens;

                  return (
                    <View
                      key={index}
                      style={{
                        width: "50%",
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => handlePackageSelect(item)}
                        style={{ position: "relative" }}
                      >
                        <Image
                          source={AppImages.Ko_Token_Bonus_Badge}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: 55,
                            height: 18,
                            zIndex: 10,
                            transform: [
                              { translateX: -10 },
                              { translateY: 10 },
                            ],
                          }}
                          resizeMode="contain"
                        />
                        <LinearGradient
                          colors={[
                            "rgba(31, 41, 55, 0.50)",
                            "rgba(17, 24, 39, 0.50)",
                          ]}
                          start={{ x: 0, y: 0 }}
                          end={{ x: 1, y: 1 }}
                          style={[
                            {
                              flex: 1,
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 18,
                              borderRadius: 10,
                              marginVertical: 5,
                              marginHorizontal: 5,
                              paddingVertical: 12,
                              paddingHorizontal: 12,
                              borderWidth: isSelected ? 2.5 : 0.8,
                              borderColor: isSelected
                                ? AppColors.appViolentColor_6D08C3
                                : "rgba(139, 147, 176, 0.10)",
                            },
                          ]}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 8,
                              marginTop: 16,
                            }}
                          >
                            <Image
                              source={AppImages.Ko_Token}
                              style={{
                                height: 44,
                                width: 44,
                              }}
                            />
                            <View style={{ gap: 6, flex: 1 }}>
                              <Text
                                style={[
                                  styles.tokenNumberRed,
                                  {
                                    fontFamily: "Anybody_700Bold",
                                    fontSize: 24,
                                    fontWeight: "700",
                                    lineHeight: 24,
                                  },
                                ]}
                              >
                                {item.tokens.toLocaleString()}
                              </Text>
                              <Text
                                style={[
                                  styles.tokenBonusGray,
                                  {
                                    fontFamily: "Anybody_400Regular",
                                    fontSize: 11,
                                    fontWeight: "400",
                                    lineHeight: 14,
                                  },
                                ]}
                              >
                                {item.baseTokens.toLocaleString()} +{" "}
                                {item.bonusTokens} bonus
                              </Text>
                            </View>
                          </View>

                          <Text
                            style={{
                              color: "#FFF",
                              textAlign: "center",
                              fontSize: 20,
                              fontWeight: "700",
                              lineHeight: 20,
                            }}
                          >
                            {item.price}
                          </Text>
                        </LinearGradient>
                      </TouchableOpacity>
                    </View>
                  );
                })}
              </View>
            )}
            <View
              style={{
                width: "100%",
                marginTop:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? 5
                    : 15,
              }}
            >
              <View
                style={{
                  padding: 12,
                  borderRadius: 14,
                  borderWidth: 0.8,
                  borderColor: "rgba(139, 147, 176, 0.10)",
                  backgroundColor: "#141927",
                  minHeight: 145,
                  gap: 15,
                  marginTop: 0,
                  maxWidth:
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? "100%"
                      : 650,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <View
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 12,
                      borderWidth: 2,
                      borderColor: AppColors.koBrandRed,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.koBrandRed,
                        fontSize: 16,
                        fontWeight: "700",
                      }}
                    >
                      !
                    </Text>
                  </View>
                  <Text
                    style={{
                      color: AppColors.white,
                      fontSize: 18,
                      fontWeight: "700",
                      lineHeight: 28,
                    }}
                  >
                    Token Information
                  </Text>
                </View>
                <View style={{ gap: 8 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 10,
                      alignItems: "flex-start",
                    }}
                  >
                    <View
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: 3,
                        backgroundColor: AppColors.koBrandRed,
                        marginTop: 7,
                      }}
                    />
                    <Text
                      style={{
                        flex: 1,
                        color: AppColors.white,
                        fontSize: 14,
                        fontWeight: "400",
                        lineHeight: 20,
                      }}
                    >
                      <Text style={{ fontWeight: "700" }}>Exchange Rate:</Text>{" "}
                      1 Token = £0.011 credit value
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 10,
                      alignItems: "flex-start",
                    }}
                  >
                    <View
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: 3,
                        backgroundColor: AppColors.koBrandRed,
                        marginTop: 7,
                      }}
                    />
                    <Text
                      style={{
                        flex: 1,
                        color: AppColors.white,
                        fontSize: 14,
                        fontWeight: "400",
                        lineHeight: 20,
                      }}
                    >
                      <Text style={{ fontWeight: "700" }}>
                        1 Credit = £0.010 payout value
                      </Text>{" "}

                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 10,
                      alignItems: "flex-start",
                    }}
                  >
                    <View
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: 3,
                        backgroundColor: AppColors.koBrandRed,
                        marginTop: 7,
                      }}
                    />
                    <Text
                      style={{
                        flex: 1,
                        color: AppColors.gray_8B93B0,
                        fontSize: 14,
                        fontWeight: "400",
                        lineHeight: 20,
                      }}
                    >
                      Tokens can't be withdrawn or converted directly.
                    </Text>
                  </View>
                </View>
              </View>
              <LinearGradient
                colors={["#111827", "#000"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 16,
                  borderRadius: 8,
                  marginTop: 15,
                  gap: 15,
                }}
              >
                {/* Left side - Text items in column for mobile, row for desktop */}
                <View
                  style={{
                    flexDirection:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "column"
                        : "row",
                    alignItems:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? "flex-start"
                        : "center",
                    gap:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 8
                        : 15,
                    flex: 1,
                  }}
                >
                  <TouchableOpacity
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <View
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        borderWidth: 2,
                        borderColor: AppColors.white,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.white,
                          fontSize: 12,
                          fontWeight: "700",
                        }}
                      >
                        !
                      </Text>
                    </View>
                    <Text
                      style={{
                        color: AppColors.gray_8B93B0,
                        fontSize: 12,
                        fontWeight: "400",
                        lineHeight: 16,
                      }}
                    >
                      Learn about token system
                    </Text>
                  </TouchableOpacity>
                  <Text
                    style={{
                      color: AppColors.gray_8B93B0,
                      fontSize: 12,
                      fontWeight: "400",
                      lineHeight: 16,
                    }}
                  >
                    Exchange Rate: 1 Token = £0.011
                  </Text>
                </View>

                {/* Desktop only - Payment methods */}
                {deviceSize !== DEVICE_SIZES.XS &&
                  deviceSize !== DEVICE_SIZES.SM && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 15,
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.white,
                          fontSize: 12,
                          fontWeight: "400",
                          lineHeight: 16,
                        }}
                      >
                        payments method
                      </Text>
                      <Image
                        source={AppImages.icPaymentmethod}
                        style={{
                          height: 24,
                          width: 200,
                          resizeMode: "contain",
                        }}
                      />
                    </View>
                  )}

                {/* Purchase button */}
                <TouchableOpacity
                  style={{
                    backgroundColor: isPurchasing
                      ? AppColors.gray_838383
                      : AppColors.red_D43639,
                    borderRadius: 8,
                    paddingVertical: 12,
                    paddingHorizontal:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 20
                        : 30,
                    minWidth:
                      deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? 120
                        : 180,
                    opacity: isPurchasing ? 0.7 : 1,
                  }}
                  onPress={handlePurchase}
                  disabled={isPurchasing}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_14,
                      { color: AppColors.white, textAlign: "center" },
                    ]}
                  >
                    {isPurchasing ? "Processing..." : "Purchase now"}
                  </Text>
                </TouchableOpacity>
              </LinearGradient>
            </View>
          </ScrollView>

          {showVerification && (
            <VerificationModal
              showModal={showVerification}
              setShowModal={setShowVerification}
              pinVerifySuccess={() => {
                setShowSuccessModal(true);
              }}
            />
          )}

          {showSuccessModal && (
            <PurchaseSuccess
              showModal={showSuccessModal}
              setShowModal={setShowSuccessModal}
              pinVerifySuccess={() => { }}
            />
          )}
          {showPaymentScreen && (
            <PaymentScreen
              showModal={showPaymentScreen}
              setShowModal={setShowPaymentScreen}
              paymentCreateSessionData={paymentCreateSessionData}
              paymentSuccess={(data) => {
                console.log("paymentSuccess data:- ", data);
              }}
            />
          )}
        </View>
      )}
    </View>
  );
};

export default PurchaseScreen;

const useStyles = CreateResponsiveStyle(
  {
    counterWrapper: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: AppColors.black_040404,
      borderRadius: 10,
      width: 203,
      height: 40,
      justifyContent: "space-between",
    },
    tokenNumberRed: {
      color: AppColors.koBrandRed,
    },
    tokenBonusGray: {
      color: AppColors.gray_8B93B0,
    },
    button: {
      width: 30,
      height: 30,
      borderRadius: 20,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
    },
    disabledButton: {
      backgroundColor: "gray",
    },

    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    needHelpButtonStyle: {
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 20,
      marginVertical: 5,
      gap: 8,
    },
    packegeSelectionView: {
      flexDirection: "row",
      overflow: "hidden",
    },

    tokenButtonStyle: {
      justifyContent: "center",
      alignItems: "center",
      padding: 10,
      paddingHorizontal: 29,
    },
    packageBgView: {
      backgroundColor: AppColors.purple_453B50,
      justifyContent: "space-between",
      borderRadius: 10,
      marginVertical: 5,
      marginHorizontal: 5,
      paddingHorizontal: 15,
      paddingVertical: 12,
      width: 264,
      height: 140,
    },
    purchaseNowButtonStyle: {
      width: 212,
      height: 40,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      justifyContent: "center",
      paddingHorizontal: 30,
    },
    backBtn: {
      width: 212,
      height: 40,
      backgroundColor: "#000000",
      borderWidth: 1,
      borderColor: "#FFFFFF",
      color: AppColors.black,
      borderRadius: 10,
      justifyContent: "center",
      paddingHorizontal: 30,
    },
    inputText: {
      width: 85,
      // textAlign: "right",
      color: AppColors.black,
      outlineStyle: "none",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },

      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },

      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.LG]: {
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },

      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.SM]: {
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },

      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
      packageBgView: {
        width: "auto",
        height: "auto",
        // height: 79,
      },
    },
    [DEVICE_SIZES.XS]: {
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },

      purchaseNowButtonStyle: {
        width: 155,
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
      backBtn: {
        width: 155,
      },
      packageBgView: {
        width: "auto",
        height: "auto",
      },
    },
  }
);
